import { PapiBadge } from '@wix/da-types-papi';

export interface GivableBadgeItemsHashInterface {
  [propName: string]: PapiBadge;
}

export const givableBadgeItemsHash: GivableBadgeItemsHashInterface = {
  llama: {
    name: 'llama',
    title: 'Llama',
    baseTitle: 'Llama',
    description: 'Llamas are awesome!',
    stackCount: 1,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/llama.gif',
        className: '',
      },
    ],
  },
  cake: {
    name: 'cake',
    title: 'Cake',
    baseTitle: 'Cake',
    description: "My, that's a delicious cake",
    stackCount: 1,
    images: [
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/base06.gif',
        className: 'cake-base',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-1',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-2',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-3',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-4',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-5',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/wax-blue01.gif',
        className: 'cake-candle cake-candle-6',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame01.gif',
        className: 'cake-flame cake-flame-1',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame02.gif',
        className: 'cake-flame cake-flame-2',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame04.gif',
        className: 'cake-flame cake-flame-3',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame03.gif',
        className: 'cake-flame cake-flame-4',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame01.gif',
        className: 'cake-flame cake-flame-5',
      },
      {
        imageUrl: 'https://st.deviantart.net/badges/cake/flame02.gif',
        className: 'cake-flame cake-flame-6',
      },
    ],
  },
};

const givableBadgeItems: PapiBadge[] = Object.keys(givableBadgeItemsHash).map(
  badgeKey => {
    return givableBadgeItemsHash[badgeKey];
  }
);

export default givableBadgeItems;
